import axios from "axios";
const ajax = axios.create({
    timeout: 30000
});
export default {
    install(Vue) {
        Vue.prototype.$ajax = function(config) {
        ajax.interceptors.request.use(
            config => {
                return config;
            },
            error => {
            this.$Notice.error({
                title: "请求错误",
                desc: error.message
            });
            return Promise.reject(error);
            }
        );
        // 响应拦截器
        ajax.interceptors.response.use(
            response => {
            return response;
            },
            error => {
            if (error.response) {
                this.$Notice.error({
                title: "服务端响应错误",
                desc: `error.response.data:${error.response.data}<br>
                        error.response.status:${error.response.status}<br>
                        error.response.headers:${error.response.headers}`
                });
            } else if (error.request) {
                this.$Notice.error({
                title: "服务端响应错误",
                desc: `error.request:${error.request}`
                });
            } else {
                this.$Notice.error({
                title: "服务端响应错误",
                desc: `错误消息:${error.message}`
                });
            }
            return Promise.reject(error);
            }
        );
        return ajax(config);
        };
    }
};
